import { useRef, useEffect } from "react";
import { Link } from "@tanstack/react-router";
import NavbarSearch from "./navbar-search";
import "../styles/components/navbar.css";

let hasAnimated = false;

export default function Navbar() {
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!hasAnimated && navRef.current) {
      hasAnimated = true;
      navRef.current.classList.add("navbar--animate");
    }
  }, []);

  return (
    <nav ref={navRef}>
      <div className="navbar__title">
        <Link to="/">Business Directory</Link>
      </div>
      <div className="navbar__navigation-menu">
        <NavbarSearch />
        <Link to="/">Directory</Link>
      </div>
    </nav>
  );
}
